var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isShowTop)?_c('van-icon',{staticClass:"top-btn",attrs:{"name":"arrow-up"},on:{"click":_vm.scrollTop}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }